import { Route } from 'react-router-dom';
import { AdminLayout } from '../components/admin/AdminLayout';
import AdminDashboard from '../components/admin/AdminDashboard';
import { AdminUsersPage } from '../components/admin/AdminUsersPage';
import { AdminApplicationsPage } from '../components/admin/AdminApplicationsPage';
import { AdminNotificationsPage } from '../components/admin/AdminNotificationsPage';
import { AdminBlogPage } from '../components/admin/AdminBlogPage';
import { AdminPaymentsPage } from '../components/admin/AdminPaymentsPage';

// Telas admin montadas: dashboard, users, candidaturas, notificações, blog, pagamentos.
export const adminRoutes = (
  <>
    <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
    <Route path="/admin/users" element={<AdminLayout><AdminUsersPage /></AdminLayout>} />
    <Route path="/admin/work-applications" element={<AdminLayout><AdminApplicationsPage /></AdminLayout>} />
    <Route path="/admin/applications" element={<AdminLayout><AdminApplicationsPage /></AdminLayout>} />
    <Route path="/admin/notifications" element={<AdminLayout><AdminNotificationsPage /></AdminLayout>} />
    <Route path="/admin/blog" element={<AdminLayout><AdminBlogPage /></AdminLayout>} />
    <Route path="/admin/payments" element={<AdminLayout><AdminPaymentsPage /></AdminLayout>} />
  </>
);